onLoad(($) => {
  const nodes = $('.JS-proposals-limit-per-page');

  if (!nodes.length) return;

  $('[id=proposals_per_page]').change(
    function() {
      let currentUrl = document.location.href;
      var url = new URL(currentUrl);
      url.searchParams.set('proposals_per_page', $(this).val());
      url.searchParams.delete('proposals_page'); // Reset to first page
      document.location = url;
    });
});
